import React, { Component } from 'react';
import { db } from '../firebase';
import _ from 'lodash';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

export default class Cash extends Component {

    constructor() {
        super();
        this.state = {
            year: new Date().getFullYear(),
            transfers: []
        }
        this.onYearChanged = this.onYearChanged.bind(this);
    }

    onYearChanged(year) {

        this.setState({
            year: year
        })
    }


    componentDidMount() {

        this.loadYearData();
    }

    componentDidUpdate(previousProps, previousState) {

        if (previousState.year !== this.state.year) {

            this.loadYearData();
        }
    }

   async loadYearData() {

        let items = await db.getCashTransactionsByDate(this.state.year + "-01-01", this.state.year + "-12-31");
        this.setState({
            transfers: items.filter(a => a).map((p_data) => {

                if (p_data) {

                    let date = new Date(p_data.date);
                    p_data.month = date.getMonth();
                    if (p_data.direction === 'withdraw') {
                        p_data.amount = p_data.amount * -1;
                    }
                    return p_data;
                }
            })
        });
    }

    render() {


        let master_total = (this.state.transfers && this.state.transfers.length) && this.state.transfers.reduce((acc, curr) => {

            return acc + curr.amount;
        }, 0);

        var chart_label = [];
        var chart_data = [];
        var chart_color = [];
        let monthly_summary = _.orderBy(_.groupBy(this.state.transfers, "month"), "key", "asc");
        Object.keys(monthly_summary).forEach(key => {

            let net_total = monthly_summary[key].reduce((a, c) => { return a + c.amount }, 0);
            chart_label.push(moment().month(key).format('MMMM'));
            chart_data.push(net_total > 0 ? net_total : net_total * -1);
            chart_color.push(net_total > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)");



        });
        let now_year = new Date().getFullYear();
        let year_options = [now_year, now_year - 1, now_year - 2, now_year - 3];
        let current_year = this.state.year;
        let onYearChanged = this.onYearChanged;
        return (
            <div className="ss-container-stacked ss-page">
                <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                    <div class="navbar-brand">
                        <a class="navbar-item" onClick={this.props.toggleDrawer}>
                            <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                        </a>
                    </div>
                    <div className="navbar-start">
                        <div className="navbar-item">
                            <div>
                                <p className="title is-4"><i className="fa fa-money" style={{ marginRight: "0.75em" }}></i>Cash</p>
                            </div>
                        </div>
                    </div>
                </nav>
                <section class="section  ss-container-stacked ss-fluid-row" style={{ backgroundColor: "hsl(0, 0%, 96%)" }}>
                    <div className="card ss-fixed-row" style={{ paddingTop: 10 }}>
                        <div class="tabs is-medium">
                            <ul>
                                {year_options.map(function (c_year) {

                                    return (<li className={c_year === current_year ? 'is-active' : ''}><a onClick={() => onYearChanged(c_year)} >{c_year}</a></li>)
                                })} </ul>
                        </div>
                        <div style={{ padding: "10px" }}>
                            <Bar
                                height={250}
                                data={{
                                    labels: chart_label,
                                    datasets: [{
                                        data: chart_data,
                                        backgroundColor: chart_color
                                    }]
                                }}
                                options={{
                                    legend: false,
                                    maintainAspectRatio: false,
                                    drawTicks: false,
                                    drawBorder: false,
                                    scaleShowLabels: false,
                                    scaleShowGridLines: false,
                                    responsive: true,
                                    scales: {
                                        xAxes: [{
                                            gridLines: {
                                                display: false
                                            }
                                        }],
                                        yAxes: [{
                                            gridLines: {
                                                display: false
                                            },
                                            ticks: {
                                                beginAtZero: true,
                                                userCallback: function (label, index, labels) {

                                                    if (index % 2 == 0) {

                                                        if (Math.floor(label) === label) {
                                                            return label;
                                                        }
                                                    }
                                                }
                                            }
                                        }]
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div className="card  ss-fluid-row">
                        <table className="table table is-narrow is-fullwidth table is-hoverable">
                            <thead>
                                <th><span className="is-pulled-left">Date</span></th>
                                <th><span className="is-pulled-left">Directon</span></th>
                                <th><span className="is-pulled-right">Amount</span></th>

                            </thead>
                            <tbody>
                                {this.state.transfers.map(function (transfer_item, i) {
                                    return <tr>
                                        <td>{moment(transfer_item.date).format("DD MMM")}</td>
                                        <td><span>{transfer_item.direction}</span></td>
                                        <td><span className="is-pulled-right ">${transfer_item.amount.toFixed(2)}</span></td>
                                    </tr>
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th><span className="is-pulled-right">$ {master_total.toFixed(2)}</span></th>
                                </tr>
                            </tfoot>

                        </table>
                    </div>
                </section>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/containers/cash.js